function mapMoney(money) {
    return {
        ...money,
        amount: Number(money.amount || 0),
    };
}

export default mapMoney;



// WEBPACK FOOTER //
// ./src/service/mapMoney.js